import React from "react";
import { UiInfoCard } from "../../components/cards/UiInfoCard";
import { UiPointsItem, UiWishListItem } from "../../components/cards/UiInfoCardContent";

export const WishList = (props) => {
    return (
        <>
            <UiInfoCard
                subtitle="Your Favourites"
                contentTitle="Favourites"
                linkTitle="Browse Rewards Now"
                LinkTo=""
                footer={true}
            >

                <UiWishListItem>
                    <p>Your favourites is currently empty. As soon as you add
                        items,  they will show here. From its medieval origins
                        to the digital era, learn.</p>

                    
                </UiWishListItem>

            </UiInfoCard>
        </>
    )

}